export default "__VITE_ASSET__BlTnIyRf__"